import { Component, OnInit, Input } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup } from '@angular/forms';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { LookUpLocationComponent } from '../look-up-location/look-up-location.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { travelItineraryUrl, travelAuthorUrl, TRAVELTYPE, BOOKINGTYPE, BOOKINGMETHOD, PURPOSE} from 'src/app/modules/shared/common/api';

@Component({
  selector: 'ark-header-info',
  templateUrl: './header-info.component.html',
  styleUrls: ['./header-info.component.scss']
})
export class HeaderInfoComponent implements OnInit {

  @Input() group: FormGroup;
  @Input() travel: Travel;
  @Input() data: any;
  user: User;
  objectKeys = Object.keys;
  tempOthers = '';
  expensesList:any;
  isOther:boolean = false;
  isCurrency:boolean = false;
  fromDatePicker:boolean = false;
  isCharged:boolean = false;
  employeeDetail = [];
  pipe = new DatePipe('en-US');
  grandTotal = '';

  mxDate:any;
  fDate:any;
  tDate:any;
  account_name: any;
  account_id: any;
  resultEmployee = {};

  dialogConfig:any;
  summaryDetail:any;
  detail:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  travelType = TRAVELTYPE;
  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];
  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];
  bookedOption = BOOKINGTYPE;
  bookedMethod = BOOKINGMETHOD;
  billOption = ["Store Support Center","Requestor"];

  filteredOptions: Observable<string[]>;
  filterCity = JSON.parse(localStorage.getItem('citylist'));

  filteredEmployeeID: Observable<string[]>;
  filteredEmployeeName: Observable<string[]>;
  filterEmployee = JSON.parse(localStorage.getItem('employeelist'));

  constructor(
    public auth: AuthService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.user = new User(this.auth.getAuthUser());
    this.tempOthers =  this.group.controls['others'].value;
    this.filteredOptions = this.group.get('location').valueChanges
    .pipe(
      startWith(''),
      map(val => this._filter(val))
      );

      this.filteredEmployeeName = this.group.get('complete_name').valueChanges
        .pipe(
        startWith(''),
        map(val => this._filterEmployee(val,'employee_name'))
      );
  
      this.filteredEmployeeID = this.group.get('employee_id_no').valueChanges
        .pipe(
        startWith(''),
        map(val => this._filterEmployee(val,'employee_id'))
      );

      this.employeeDetail['level'] = this.data.res.level ? this.data.res.level : this.data.res.travel_request.level;
      this.employeeDetail['department'] = this.data.res.department  ? this.data.res.department : this.data.res.travel_request.department ;
      this.employeeDetail['area_assigned'] = this.data.res.area_assigned ? this.data.res.area_assigned : this.data.res.travel_request.area_assigned;

      this.dialogConfig = new MatDialogConfig();
      this.dialogConfig.position = {
        'top': '0',
        'right': '0',
      }
      this.dialogConfig.width = '800px';
      this.dialogConfig.height = '100%';
      this.dialogConfig.disableClose = true;
      this.dialogConfig.panelClass = 'mat-dialog';
      this.group.get('purpose').valueChanges.subscribe(value => {
        if (value == "OTHERS") {
          this.isOther = true;
          if (this.data.res.travel_summary.others == '') {
            this.group.get('others').setValue('');
          }
          if (!this.tempOthers) {
            this.group.get('others').reset();
          }
        } else {
          this.isOther = false;
        }
      });
      this.isOther = this.data.isOther;

      if (this.data.res.travel_summary) {
        this.fDate = this.pipe.transform(this.data.res.travel_summary.inclusive_date_from, 'yyyy-MM-dd');
        this.tDate = this.pipe.transform(this.data.res.travel_summary.inclusive_date_to, 'yyyy-MM-dd');

        if (this.data.res.travel_summary.currency_category == 3) {
          this.group.get('currency').setValue(this.data.res.travel_summary.currency);
          this.isCurrency = true;
        }

        if (this.data.res.travel_summary.charged_to_category == 3) {
          this.group.get('charged_to').setValue(this.data.res.travel_summary.charged_to);
          this.isCharged = true;
        }
        
      }

      if (this.data.res.travel_request.travel_summary) {
        this.fDate = this.pipe.transform(this.data.res.travel_request.travel_summary.inclusive_date_from, 'yyyy-MM-dd');
        this.tDate = this.pipe.transform(this.data.res.travel_request.travel_summary.inclusive_date_to, 'yyyy-MM-dd');

        if (this.data.res.travel_request.travel_summary.currency_category == 3) {
          this.group.get('currency').setValue(this.data.res.travel_request.travel_summary.currency);
          this.isCurrency = true;
        }
      }

      this.group.get('currency_category').valueChanges.subscribe(value => { 
        if (value == 3) {
          if (this.data.res.travel_summary.currency == '') {
            this.group.get('currency').setValue('');
          }
          this.isCurrency = true;
        } else {
          this.isCurrency = false;
        }
      })

      this.group.get('charged_to_category').valueChanges.subscribe(value => { 
        if (value == 3) {
          if (this.data.res.travel_summary.charged_to == '') {
            this.group.get('charged_to').setValue('');
          }
          this.isCharged = true;
        } else {
          this.group.get('charged_to').setValue('');
          this.isCharged = false;
        }
      })

      if (this.travel.itineraries && this.travel.itineraries.length >= 1) {
        this.travel.fromDatePicker = true;
      } else {
        this.travel.fromDatePicker = false;
      }

      this.grandTotal = this.data.res.travel_request.travel_itinerary_total ? this.data.res.travel_request.travel_itinerary_total.grand_total : this.data.res.travel_itinerary_total.grand_total;

      if(this.group.get('travel_request_type').value == 'Reimbursement'){
        let currDate = new Date();
        let yesterday = new Date(currDate.getTime() - (24*60*60*1000));
        this.tDate = this.pipe.transform(yesterday, 'yyyy-MM-dd');
        this.mxDate = this.tDate;
      }  
   }


   selectTravelRequest (e) {
    let currDate = new Date();
    let yesterday = new Date(currDate.getTime() - (24*60*60*1000));
    this.group.controls['inclusive_date_from'].setValue(null);
    this.group.controls['inclusive_date_to'].setValue(null);  
    if (e.value.toLowerCase() == 'reimbursement') {
    this.tDate = this.pipe.transform(yesterday, 'yyyy-MM-dd');
    this.mxDate = this.tDate;
    } else {
    this.tDate = '';
    this.mxDate = this.tDate;
    }
  }


  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g); // '\d'
     return pattern.test(e.key);
  }

  setEmployee(e){
    this.employeeDetail = e;
    this.account_id = e.employee_id;
    this.account_name = e.employee_name;
    this.group.controls['employee_name'].setValue(e.employee_name);
    this.group.controls['employee_id'].setValue(e.employee_id);
    this.group.controls['level'].setValue(e.level);
    this.group.controls['department'].setValue(e.department);
    this.group.controls['area_assigned'].setValue(e.area_assigned);
  }

  setEmployeeKeyEnter(type, $event) {
    if ($event.keyCode == 13) {
      if (type == 'employee_name') {
        const value = this.group.controls['employee_name'].value;
        this.resultEmployee = this.filterEmployee.filter(option => option.employee_name.toLowerCase() === value.toLowerCase());
  
        if (Object.keys(this.resultEmployee).length > 0) {
          this.setEmployee(this.resultEmployee[0]);
        } else {
          this.group.controls['employee_id'].setValue('');
          this.employeeDetail['level'] = '';
          this.employeeDetail['department'] = '';
          this.employeeDetail['area_assigned'] = '';
        }
      } else {
        const value = this.group.controls['employee_id'].value;
        this.resultEmployee = this.filterEmployee.filter(option => option.employee_id.toLowerCase() === value.toLowerCase());
  
        if (Object.keys(this.resultEmployee).length > 0) {
          this.setEmployee(this.resultEmployee[0]);
        } else {
          this.group.controls['employee_name'].setValue('');
          this.employeeDetail['level'] = '';
          this.employeeDetail['department'] = '';
          this.employeeDetail['area_assigned'] = '';
        }
      }
    } else {
      if (type == 'employee_name') {
        const value = this.group.controls['employee_name'].value;
        this.filteredEmployeeName = this.group.get('complete_name').valueChanges
          .pipe(
          startWith(''),
          map(val => this.filterEmployee.filter(option => option.employee_name.toLowerCase().includes(value.toLowerCase())))
        );
      } else {
        const value = this.group.controls['employee_id'].value;
        this.filteredEmployeeID = this.group.get('employee_id_no').valueChanges
          .pipe(
          startWith(''),
          map(val => this.filterEmployee.filter(option => option.employee_id.includes(value)))
        );
      }
    }
  }
  
  validInfo(name) {
    let result = (name == 'employee_id')? this.account_id: this.account_name;

    if (this.group.controls[name].value != result) {
      this.group.controls[name].setErrors({'invalid': true});
      this.group.controls[name].markAsTouched();
      this.group.controls[name].markAsDirty();
      return;
    }

      this.group.controls['employee_id'].setErrors({'invalid': false});
      this.group.controls['employee_id'].markAsUntouched();
      this.group.controls['employee_id'].markAsPristine();

      this.group.controls['employee_name'].setErrors({'invalid': false});
      this.group.controls['employee_name'].markAsUntouched();
      this.group.controls['employee_name'].markAsPristine();
  }

  private _filter(name: string): string[] {
    const filterValue = name.toLowerCase();
    return this.filterCity.filter(option => option.title.toLowerCase().includes(filterValue));
  }

  private _filterEmployee(name: string, option?: string): string[] {
    const filterValue = name.toLowerCase();
    if (option == 'employee_id') {
      return this.filterEmployee.filter(option => option.employee_id.includes(filterValue));
    } else {
      return this.filterEmployee.filter(option => option.employee_name.toLowerCase().includes(filterValue));
    }
   
  }

  onChangeStartDate(e) {
    this.fDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

  onChangeEndDate(e) {
    this.tDate = this.pipe.transform(e.value, 'yyyy-MM-dd');
  }

    /**
   * 1 = country
   * 2 = province
   * 3 =  city
   * 4 = barangay
   * @param i 
   */
  locationLookUp(i?:number,formInput?:string,mode?:string){
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '605px';
    this.dialogConfig.data = {
        i,
        city: this.filterCity,
        barangay: null
    }
    let dialogRef = this.dialog.open(LookUpLocationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.group.controls[formInput].setValue(result.value);
      }
    });
  }

  
/**
 * Display Purpose option
 * @param e = 3 get value for other currency
 */
displayOthers(e) {
  this.isOther = false;
}

}
